import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';

import App from './App.jsx';

import { RouterProvider } from 'react-router-dom';
import { router } from './route/router.jsx';

import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min";

import './assets/css/remixicon.css';
import './assets/css/style.scss';
import './assets/css/responsive.scss';

if (process.env.NODE_ENV === 'development') {
  const originalWarnOnce = console.warn;
  console.warn = (...args) => {
    if (!args[0]?.includes('React Router Future Flag Warning')) {
      originalWarnOnce(...args);
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
	  <Provider store={store}>
	    <RouterProvider router={router}>
	      <App />
	    </RouterProvider>
	  </Provider>
  </React.StrictMode>,
);
